import { createContext } from 'react';
import { defaultTheme } from '../const/theme';
var ThemeContext = createContext(defaultTheme);
export default ThemeContext;
